import React from "react";

const FoundationImpact = () => {
  const impactStats = [
    {
      number: "50+",
      label: "Scholarships Awarded",
    },
    {
      number: "25+",
      label: "Community Projects",
    },
    {
      number: "10+",
      label: "Partner Organizations",
    },
    {
      number: "4",
      label: "Countries Reached",
    },
  ];

  return (
    <div className="foundation-impact">
      <style jsx>{`
        .foundation-impact {
          background: linear-gradient(135deg, #f9fafb 0%, #e5e7eb 100%);
          padding: 5rem 2rem;
          {/* min-height: 100vh; */}
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;
          overflow: hidden;
        }

        .foundation-impact::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-image: radial-gradient(
              circle at 25% 25%,
              rgba(0, 117, 154, 0.05) 0%,
              transparent 50%
            ),
            radial-gradient(
              circle at 75% 75%,
              rgba(46, 49, 60, 0.03) 0%,
              transparent 50%
            );
          pointer-events: none;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
          position: relative;
          z-index: 1;
        }

        .foundation-description {
          text-align: center;
          margin-bottom: 4rem;
          max-width: 800px;
          margin-left: auto;
          margin-right: auto;
        }

        .description-text {
          font-size: 1.25rem;
          line-height: 1.8;
          color: #4b5563;
          font-weight: 400;
          margin-bottom: 3rem;
          letter-spacing: 0.025em;
        }

        .impact-section {
          text-align: center;
        }

        .section-title {
          font-size: 2.5rem;
          font-weight: 700;
          color: #2e313c;
          margin-bottom: 1rem;
          letter-spacing: -0.025em;
          position: relative;
          display: inline-block;
        }

        .title-underline {
          width: 80px;
          height: 4px;
          background: linear-gradient(90deg, #00759a, #006d8a);
          margin: 0 auto 3rem;
          border-radius: 2px;
          position: relative;
        }

        .title-underline::after {
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          width: 120px;
          height: 2px;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(0, 117, 154, 0.3),
            transparent
          );
          transform: translate(-50%, -50%);
        }

        .stats-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 2rem;
          margin-top: 2rem;
        }

        .stat-card {
          background: #ffffff;
          border-radius: 16px;
          padding: 2.5rem 2rem;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
            0 2px 4px -1px rgba(0, 0, 0, 0.06);
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
          border: 1px solid #e5e7eb;
        }

        .stat-card::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #00759a, #2e313c, #00759a);
          transform: scaleX(0);
          transition: transform 0.3s ease;
        }

        .stat-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
            0 10px 10px -5px rgba(0, 0, 0, 0.04);
          border-color: rgba(0, 117, 154, 0.2);
        }

        .stat-card:hover::before {
          transform: scaleX(1);
        }

        .stat-number {
          font-size: 3.5rem;
          font-weight: 800;
          background: linear-gradient(135deg, #00759a, #006d8a);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin-bottom: 0.5rem;
          line-height: 1;
          display: block;
        }

        .stat-label {
          font-size: 1.1rem;
          color: #4b5563;
          font-weight: 500;
          line-height: 1.4;
          letter-spacing: 0.025em;
        }

        .highlight-text {
          color: #2e313c;
          font-weight: 600;
        }

        @media (max-width: 768px) {
          .foundation-impact {
            padding: 3rem 1rem;
          }

          .description-text {
            font-size: 1.1rem;
            margin-bottom: 2rem;
          }

          .section-title {
            font-size: 2rem;
          }

          .stats-grid {
            grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
            gap: 1.5rem;
          }

          .stat-card {
            padding: 2rem 1.5rem;
          }

          .stat-number {
            font-size: 2.8rem;
          }

          .stat-label {
            font-size: 1rem;
          }
        }

        @media (max-width: 480px) {
          .stats-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <div className="container">
        <div className="foundation-description">
          <p className="description-text">
            The{" "}
            <span className="highlight-text">
              Phabyeon Burgess-Yearwood Foundation
            </span>{" "}
            is dedicated to empowering communities through education and
            collaborative initiatives. We support students, low-income
            communities, and grassroots projects to create sustainable impact
            and foster global growth.
          </p>
        </div>

        <div className="impact-section">
          <h2 className="section-title">Our Impact</h2>
          <div className="title-underline"></div>

          <div className="stats-grid">
            {impactStats.map((stat, index) => (
              <div key={index} className="stat-card">
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FoundationImpact;
